import { AdminAppState, ImageEntry } from '../../state';
import { EMPTY_IMAGE_ENTRY } from '../../constants/image';
import { getImages } from './get-images';

export const getImageEntry = (imageKey: string) => (
  state: AdminAppState,
): ImageEntry => {
  return getImages(state)[imageKey] || EMPTY_IMAGE_ENTRY;
};
